import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface ReferenceDateEvent {
  type: 'change';
  previousDate: Date | null;
  newDate: Date;
  timestamp: Date;
}

@Injectable({
  providedIn: 'root'
})
export class ReferenceDateEventsService {
  private referenceDateChangeSubject = new BehaviorSubject<ReferenceDateEvent | null>(null);

  public referenceDateChange$: Observable<ReferenceDateEvent | null> = this.referenceDateChangeSubject.asObservable();

  emitReferenceDateChange(previousDate: Date | null, newDate: Date): void {
    const event: ReferenceDateEvent = {
      type: 'change',
      previousDate,
      newDate,
      timestamp: new Date()
    };
    this.referenceDateChangeSubject.next(event);
  }

  getCurrentEvent(): ReferenceDateEvent | null {
    return this.referenceDateChangeSubject.value;
  }
} 